export const google_maps_api = {
    withApi: 'https://maps.googleapis.com'
}

export const google_maps_uri = {
    getAdress: `${google_maps_api.withApi}/maps/api/geocode/json`
}